export const isInStudio = () => {
    if (window.__SOFTR_E2E_ONLY_APP_MODE__ === "studio") {
        return true;
    }

    return (
        window.location.href.startsWith("http://localhost:4200") ||
        window.location.href.startsWith("https://studio-staging") ||
        window.location.href.startsWith("https://studio.softr.io/") ||
        "__SOFTR_IS_IN_STUDIO" in window
    );
};

declare global {
    interface Window {
        __SOFTR_E2E_ONLY_APP_MODE__?: string;
        __SOFTR_IS_IN_STUDIO?: boolean;
    }
}
